import { type ServiceMethod } from '@/application/interfaces/service';

type Params = {
  cartId: string;
};

export type Response = {
  data: Data[];
};

interface Data {
  itemId: string;
  stores: Store[];
  deliveryAvailable: boolean;
}

interface Store {
  storeId: string;
  storeName: string;
  address: Address;
  delayTime: number;
  openingHours: string[];
}

interface Address {
  street: string;
  number: number;
  district: string;
  cep: string;
  complement: string;
  reference: string;
  city: string;
  state: string;
  ibge_city_code: string;
  postal_code_type: string;
  postal_code_description: null;
}

const getAvailability: ServiceMethod<Response, Params> =
  (httpClient) => async (data, options) => {
    const { cartId } = data;

    const { body: response } = await httpClient.get<Response, Params>(
      '/api/v3/carts/{cartId}/shipment/availability',
      {
        ...options,
        params: { cartId },
      }
    );

    return response;
  };

export default getAvailability;
